import { __assign, __decorate, __extends } from "tslib";
import * as React from 'react';
import { dtoToFinishSetupProps, FinishSetup, } from './finish-setup';
import { FetchStatus } from '../view-rapper';
import { getSolutionPreviewBySlugOrId } from '../../api/api';
import { WithFetcher } from '../../component-decorators/with-fetcher';
import { CenteredLoader } from '../centered-loader';
import { withMarketplaceStore, } from '../../component-decorators/with-marketplace-store';
import { useConfigContext } from '../../config-context';
import { withExperiments } from '../../component-decorators/with-experiments';
import { getInstalledApps } from '../../common/utils';
export var FinishSetupContainer = function (props) {
    var configContext = useConfigContext();
    return (React.createElement(FinishSetupConnectedContainer, __assign({}, props, { configContext: configContext })));
};
var FinishSetupConnectedContainer = /** @class */ (function (_super) {
    __extends(FinishSetupConnectedContainer, _super);
    function FinishSetupConnectedContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.dataFetcher = function () {
            var useNewApi = _this.props.experiments &&
                _this.props.experiments.enabled('specs.marketplace.newMarketApi');
            var getAppInstance = _this.props.configContext.getAppInstance;
            var signedInstance = getAppInstance
                ? getAppInstance('22bef345-3c5b-4c18-b782-74d4085112ff')
                : undefined;
            return getInstalledApps(signedInstance).then(function (apps) {
                var appFromInstalled = apps === null || apps === void 0 ? void 0 : apps.find(function (installedApp) { return installedApp.webSolutionBase.id === _this.props.slug; });
                if (appFromInstalled) {
                    return appFromInstalled;
                }
                return getSolutionPreviewBySlugOrId(_this.props.slug, _this.props.configContext.locale, useNewApi).then(function (webSolution) {
                    return webSolution;
                });
            });
        };
        _this.state = {
            isFetchingData: FetchStatus.FETCHING,
            finishSetupProps: null,
        };
        return _this;
    }
    FinishSetupConnectedContainer.prototype.render = function () {
        var _this = this;
        return (React.createElement(WithFetcher, { loader: React.createElement(CenteredLoader, null), initialFetch: this.dataFetcher, fetchMemoizationId: "finish-setup" }, function (_a) {
            var fetchData = _a.fetchData;
            return (React.createElement(FinishSetup, __assign({}, dtoToFinishSetupProps(fetchData, _this.props.appVersion))));
        }));
    };
    FinishSetupConnectedContainer = __decorate([
        withMarketplaceStore,
        withExperiments
    ], FinishSetupConnectedContainer);
    return FinishSetupConnectedContainer;
}(React.Component));
export { FinishSetupConnectedContainer };
//# sourceMappingURL=finish-setup-container.js.map